import { CommonModule, NgClass } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import { ProjectFormComponent } from '@cabinet/components/project-form/project-form.component';
import { ProjectMenuComponent } from '@cabinet/components/project-menu/project-menu.component';
import { IdentityModel } from '@core/models/identity.model';
import { ProjectModel } from '@core/models/project.model';
import * as AuthActions from '@core/redux/auth/auth.actions';
import * as fromRoot from '@core/redux/index';
import * as PopupActions from '@core/redux/popup/popup.actions';
import * as ProjectActions from '@core/redux/project/project.actions';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: true,
  styleUrls: ['./dashboard.component.less'],
  imports: [NgClass, CommonModule, ProjectFormComponent, ProjectMenuComponent, RouterModule],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit {
  private readonly store = inject<Store<fromRoot.State>>(Store);
  private readonly destroyRef = inject(DestroyRef);
  loading: boolean = false;

  popupProjectMenu$: Observable<any>;
  popupProjectForm$: Observable<any>;
  subscription$: Subscription = new Subscription();
  isArchiveProjectList = false;
  isOpenChangeProjectListPopup = false;
  user: IdentityModel;

  activeProjectList: ProjectModel[] = [];
  archiveProjectList: ProjectModel[] = [];

  get activeProjectListGetter(): ProjectModel[] {
    return this.activeProjectList;
  }

  get archiveProjectListGetter(): ProjectModel[] {
    return this.archiveProjectList;
  }

  constructor() {
    this.popupProjectMenu$ = this.store.pipe(select(fromRoot.getPopupProjectMenu));
    this.popupProjectForm$ = this.store.pipe(select(fromRoot.getPopupProjectForm));
  }

  ngOnInit() {
    this.loading = true;
    this.store.dispatch(new ProjectActions.SearchAction());
    this.store.dispatch(new AuthActions.GetUserAction());

    this.store
      .pipe(select(fromRoot.getUser), takeUntilDestroyed(this.destroyRef))
      .subscribe(user => (this.user = user));

    this.store
      .pipe(select(fromRoot.getProjectActiveEntities), takeUntilDestroyed(this.destroyRef))
      .subscribe((projects: ProjectModel[]) => {
        this.activeProjectList = projects;
        this.loading = false;
      });

    this.store
      .pipe(select(fromRoot.getProjectArchiveEntities), takeUntilDestroyed(this.destroyRef))
      .subscribe((projects: ProjectModel[]) => (this.archiveProjectList = projects));
  }

  onOpenCreateForm($event) {
    $event.stopPropagation();
    $event.preventDefault();
    let position = 0;
    const popupHeight = 295;
    const halfPopupHeight = popupHeight / 2;
    const screenHeight = window.innerHeight;
    const topHeight = $event.pageY;
    const bottomHeight = screenHeight - topHeight;

    if (halfPopupHeight <= topHeight && halfPopupHeight <= bottomHeight) {
      position = topHeight - halfPopupHeight;
    } else if (halfPopupHeight > topHeight) {
      position = 15;
    } else if (halfPopupHeight > bottomHeight) {
      position = screenHeight - popupHeight - 15;
    }
    this.store.dispatch(new PopupActions.OpenProjectFormMenu(position, 100));
  }

  onOpenProjectMenu($event, projectId) {
    $event.stopPropagation();
    $event.preventDefault();
    const bottom = window.innerHeight - $event.pageY - 67;
    const position = bottom < 15 ? 15 : bottom;
    this.store.dispatch(new ProjectActions.SelectUpdateAction(projectId));
    this.store.dispatch(new PopupActions.OpenProjectMenu(position));
  }

  onChangeProjectList(isArchiveProjectList: boolean) {
    this.isArchiveProjectList = isArchiveProjectList;
    this.isOpenChangeProjectListPopup = false;
  }

  onOpenChangeProjectListPopup() {
    this.isOpenChangeProjectListPopup = !this.isOpenChangeProjectListPopup;
  }
}
